import React, { useState, useRef, useEffect,useContext } from 'react';
import { Container, Button, Form, Row, Col } from 'react-bootstrap';
import Image from 'react-bootstrap/Image';
import { Link } from 'react-router-dom';
import Modal from 'react-bootstrap/Modal'
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import Dropdown from 'react-bootstrap/Dropdown';
import { removeUserSession } from '../Utils/Common';
import API from '../Utils/Api';
import { validatelocationsearch } from '../Utils/validate';


import { LocationContext } from "./LocationContext";

const Topbar = ({ toggleSidebar }) => {
  const { cur_location,getCurrentLocation,setTownLocation } = useContext(LocationContext);
  const [expanded, setExpanded] = useState(false);
  const navRef = useRef(null);

  const [menuarray, setMenuarray] = useState([]);

  const [location, setLocation] = useState([]);
  const [errors, setErrors] = useState({});
    const [state, setState] = useState([]);
    const [city, setCity] = useState([]);
    const [town, setTown] = useState([]);

    const [inputsl, setInputsl] = useState({ pincode: '', state: '', city: '', town: '',town_name:'' });

    const [logo, setLogo] = useState('');

  // Close navbar when clicking outside
  useEffect(() => {

    API.post('get_settings')
      .then(response => {
          
          if (response.data.status === false) {

          } else {
              setLogo(response.data.data.app_neighbour_logo);
          }
      }).catch(error => {
          
      });

    if (localStorage.getItem("token")) {
    /* Start get profile */
    API.get('get_user_detail')
      .then(response => {

        if (response.data.status === false) {

        } else {
          // console.log('success ')
          setLocation(response.data.data.location);
        }
      }).catch(error => {

      });
    }
    /* Start get deal */
    let formData = new FormData();
    formData.append(`per_page`, 8);
    formData.append(`location_pincode`, '');
    formData.append(`location_town`, '');

    var url = 'get_deal';
    if (localStorage.getItem("token")) {
      url = 'get_deal_with_login';
    }
    formData.append('location_id', localStorage.getItem('location_id') || '');
    API.post(url, formData)
      .then(response => {
        
        if (response.data.status === false) {

        } else {
          setMenuarray(response.data.data.menu_array);
        }
      }).catch(error => {
        
      })
    /* End get profile */

      API.post('get_state')
        .then(response => {
            setState(response.data.data);
        });

    const handleClickOutside = (event) => {
      if (navRef.current && !navRef.current.contains(event.target)) {
        setExpanded(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

 

  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [showInfo, setShowInfo] = useState(false);
  const handleInfo = () => {
    setShowInfo(prev => !prev);
  };
  const [hidePopInfo, setShowPopInfo] = useState(true);
  const handlePopInfo = () => {
    setShowPopInfo(false);
    //setShowInfo(false);
  };

  const sel_location = (val) => {
    localStorage.setItem("location_without_login_id", val.id);
    localStorage.setItem("location_without_login", val.name);
    window.location.href = "/deal";
  };

const getCity = (event) => {
      event.preventDefault();
      setInputsl(inputsl => ({ ...inputsl, [event.target.name]: event.target.value }));

      setTown([]);

      var st = 'city';
      var st_val = '';
      setInputsl(inputsl => ({ ...inputsl, [st]: st_val }));

      var ct = 'town';
      var ct_val = '';
      setInputsl(inputsl => ({ ...inputsl, [ct]: ct_val }));

      var ctt = 'category_id';
      var ctt_val = '';
      setInputsl(inputsl => ({ ...inputsl, [ctt]: ctt_val }));

      let formData = new FormData();
      formData.append('state_id', event.target.value);
      API.post('get_city', formData)
          .then(response => {

              if (response.data.status === true) {
                  setCity(response.data.data);
              } else {

              }
          }).catch(error => {

          });
  }

    const getTown = (event) => {
        event.preventDefault();
        setInputsl(inputsl => ({ ...inputsl, [event.target.name]: event.target.value }));
        setTown([]);

        var ct = 'town';
        var ct_val = '';
        setInputsl(inputsl => ({ ...inputsl, [ct]: ct_val }));

        var ctt = 'category_id';
        var ctt_val = '';
        setInputsl(inputsl => ({ ...inputsl, [ctt]: ctt_val }));
        let formData = new FormData();
        formData.append('city_id', event.target.value);
        API.post('get_town', formData)
            .then(response => {
                if (response.data.status === true) {
                    setTown(response.data.data);
                    var ct1 = 'town';
                  var ct_val1 = response.data.extra_data.town_id;
                  setInputsl(inputsl => ({ ...inputsl, [ct1]: ct_val1 }));

                  var pin1 = 'pincode';
                  var pin_val1 = response.data.extra_data.pincode;
                  setInputsl(inputsl => ({ ...inputsl, [pin1]: pin_val1 }));

                  var town_text=response.data.extra_data.town_name;
                  var town_name_lbl="town_name";
                  setInputsl(inputsl => ({ ...inputsl, [town_name_lbl]: town_text }));
                } else {

                }
            }).catch(error => {

            });
    }
    const getCat = (event) => {
        event.preventDefault();
         const selectedIndex = event.target.selectedIndex;
        setInputsl(inputsl => ({ ...inputsl, [event.target.name]: event.target.value }));

        var town_text=event.target.options[selectedIndex].text;
        var town_name_lbl="town_name";
        setInputsl(inputsl => ({ ...inputsl, [town_name_lbl]: town_text }));

        get_town_picode(event.target.value);
    }
    const get_town_picode = (id) => {
        let formData = new FormData();
        formData.append('town_id', id);
        API.post('get_town_pincode', formData)
            .then(response => {

                if (response.data.status === true) {
                    if (response.data.data.city_id !== '') {
                        var pincode_label = 'pincode';
                        var pincode_val = response.data.data.pincode;
                        setInputsl(inputsl => ({ ...inputsl, [pincode_label]: pincode_val }));
                    }
                } else {

                }
            }).catch(error => {

            });
    }
    const handleInputChangeMo = (event) => {
        event.persist();
        const { name, value } = event.target;

        // Allow only numbers (0–9)
        const regex = /^[0-9]*$/;

        if (regex.test(value)) {
            setInputsl(inputsl => ({ ...inputsl, [name]: value }));
        }
    }
  const getpicode_town = () => {
        setCity([]);
        setTown([]);
        var state_label1 = 'state';
        var state1 = '';
        setInputsl(inputsl => ({ ...inputsl, [state_label1]: state1 }));

        var city_label1 = 'city';
        var city1 = '';
        setInputsl(inputsl => ({ ...inputsl, [city_label1]: city1 }));

        var town_label1 = 'town';
        var town1 = '';
        setInputsl(inputsl => ({ ...inputsl, [town_label1]: town1 }));
        if (inputsl.pincode !== '') {
            let formData = new FormData();
            formData.append('pin_code', inputsl.pincode);
            API.post('get_pincode_town', formData)
                .then(response => {

                    if (response.data.status === true) {
                        if (response.data.data.city_id !== '' && response.data.data.city_id !== '') {
                            setCity(response.data.data.city);
                            setTown(response.data.data.town);
                            var state_label = 'state';
                            var state = response.data.data.state_id;
                            setInputsl(inputsl => ({ ...inputsl, [state_label]: state }));

                            var city_label = 'city';
                            var city = response.data.data.city_id;
                            setInputsl(inputsl => ({ ...inputsl, [city_label]: city }));

                            var town_label = 'town';
                            var town = response.data.data.town_id;
                            setInputsl(inputsl => ({ ...inputsl, [town_label]: town }));

                            var town_text=response.data.data.town_name;
                            var town_name_lbl="town_name";
                            setInputsl(inputsl => ({ ...inputsl, [town_name_lbl]: town_text }));
                        }else{
                              setCity([]);
                              setTown([]);
                              var state_label3 = 'state';
                              var state3 = '';
                              setInputsl(inputsl => ({ ...inputsl, [state_label3]: state3 }));

                              var city_label3 = 'city';
                              var city3 = '';
                              setInputsl(inputsl => ({ ...inputsl, [city_label3]: city3 }));

                              var town_label3 = 'town';
                              var town3 = '';
                              setInputsl(inputsl => ({ ...inputsl, [town_label3]: town3 }));

                              var town_text3='';
                                  var town_name_lbl3="town_name";
                                  setInputsl(inputsl => ({ ...inputsl, [town_name_lbl3]: town_text3 }));
                        }
                    } else {
                        setCity([]);
                        setTown([]);
                        var state_label1 = 'state';
                        var state1 = '';
                        setInputsl(inputsl => ({ ...inputsl, [state_label1]: state1 }));

                        var city_label1 = 'city';
                        var city1 = '';
                        setInputsl(inputsl => ({ ...inputsl, [city_label1]: city1 }));

                        var town_label1 = 'town';
                        var town1 = '';
                        setInputsl(inputsl => ({ ...inputsl, [town_label1]: town1 }));

                        var town_text1='';
                        var town_name_lbl1="town_name";
                        setInputsl(inputsl => ({ ...inputsl, [town_name_lbl1]: town_text1 }));

                    }
                }).catch(error => {

                });
        }else{
            setCity([]);
            setTown([]);
            var state_label2 = 'state';
            var state2 = '';
            setInputsl(inputsl => ({ ...inputsl, [state_label2]: state2 }));

            var city_label2 = 'city';
            var city2 = '';
            setInputsl(inputsl => ({ ...inputsl, [city_label2]: city2 }));

            var town_label2 = 'town';
            var town2 = '';
            setInputsl(inputsl => ({ ...inputsl, [town_label2]: town2 }));

            var town_text2='';
                var town_name_lbl2="town_name";
                setInputsl(inputsl => ({ ...inputsl, [town_name_lbl2]: town_text2 }));
        }
    }
    const submitdata = () => {
      const validationErrors = validatelocationsearch(inputsl);
        const noErrors = Object.keys(validationErrors).length === 0;
        setErrors({});
        setErrors(validationErrors);

        if (noErrors) {
            setTownLocation(inputsl.town_name,inputsl.town,inputsl.pincode,inputsl.city);
            setShow(false);
        }
    }

  /* Start logout */
  const logout = () => {
    removeUserSession();
    window.location.href = "/";
    //<Navigate to="/" />
  }
  /* End logout */



  return (
    <>
      {hidePopInfo && (
        <div className='info-box'>

          <Container>

            {/* <Row className='info-top'>
              <Col><p>Weekend plans need a little extra? extra 15% off should help!</p></Col>
              <Col xs="auto" className='d-flex'>
                <Link to="" onClick={handleInfo}> <span> {showInfo ? 'Hide Detail' : 'View Detail'} </span> <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/drop-wh.webp'} className={`img-fluid ${showInfo ? 'tr180' : ''}`} alt="drop-wh" /></Link>
                <Link to="" onClick={handlePopInfo}> <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/cross.webp'} className="img-fluid info-close" alt="info" /> </Link>
              </Col>
            </Row>

            {showInfo && (
              <div className='info-bot'>
                <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/info.webp'} className="img-fluid" alt="info" />
                <p>jsdjk sjksjkl jsdkljf sdkljfklsdnkljnsdklfj sdkljklsdjfksjfkljsdlkj</p>
              </div>
            )} */}
            {hidePopInfo && menuarray.length <= 1 &&
              menuarray.map((val, index) => (
                <>
                  <Row className='info-top'>
                    <Col><p>{val.title}</p></Col>
                    <Col xs="auto" className='d-flex'>
                      <Link to="" onClick={handleInfo}> <span> {showInfo ? 'Hide Detail' : 'View Detail'} </span> <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/drop-wh.webp'} className={`img-fluid ${showInfo ? 'tr180' : ''}`} alt="drop-wh" /></Link>
                      <Link to="" onClick={handlePopInfo}> <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/cross.webp'} className="img-fluid info-close" alt="info" /> </Link>
                    </Col>
                  </Row>

                  {showInfo && (
                    <div className='info-bot'>
                      <Image src={val.image} className="img-fluid" alt="info" />
                      <p>{val.description}</p>
                    </div>
                  )}
                </>
              ))
            }


          </Container>
        </div>
      )}
      <section className='wh-header'>
        <Container>

          <div className='nei-header before-login-header user-header'>
            <div>
              <div className='d-none'>
                <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/location-wh.webp'} className="img-fluid d-none" alt="location-wh" />
                <h6 className='d-none'>Nasik Local</h6>
                <Link to="" onClick={handleShow} className=''>
                  <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/search-wh.webp'} className="img-fluid" alt="search-wh" />
                </Link>
              </div>

              {/* <div className='header-loc-box'>
                <h6 onClick={handleShow}>{localStorage.getItem('location_without_login') || 'My Locations'}</h6>
                <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/drop-wh.webp'} className="img-fluid" alt="drop" />
              </div> */}

              <div className="header-loc-box mob-hide">
                <Dropdown>
                  <Dropdown.Toggle variant="success" id="ciytdrop" className='header-loc-box'>
                    <h6 onClick={handleShow}>{cur_location.address ? cur_location.address : "Select Location"}</h6>
                    <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/location.webp'} className="img-fluid" alt="drop" onClick={getCurrentLocation} />
                  </Dropdown.Toggle>
                  {/*<Dropdown.Menu className='header-loc-drop header-drop'>
                    <h6>My Locations</h6>
                    {location && location.map((val, index) => {
                      return (
                        <Link to="" onClick={() => sel_location(val)}>
                          <div>
                            <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/city.webp'} className="img-fluid img-loc" alt="city" />
                            <h6>{val.town_name} - {val.pincode}</h6>
                          </div>
                        </Link>
                      );
                    })}
                    <h6>Add New Locations</h6>
                    <Link to="" className='ant-box' onClick={handleShow}>
                      <div>
                        <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/open.webp'} className="img-fluid img-loc" alt="open" />
                        <h6>Select Location</h6>
                      </div>
                    </Link>
                  </Dropdown.Menu>*/}
                </Dropdown>
              </div>

              <Dropdown className="drp-loc d-none">
                <Dropdown.Toggle variant="success" id="ciytdrop" className='header-loc-box'>
                  <h6>{localStorage.getItem('location_without_login') || 'My Locations'}</h6>
                  <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/drop-wh.webp'} className="img-fluid" alt="drop" />
                </Dropdown.Toggle>
                <Dropdown.Menu className='header-loc-drop header-drop drop-scroll-x'>
                  <h6>My Locations</h6>
                  {location && location.map((val, index) => {
                    return (
                      <Link to="" onClick={() => sel_location(val)}>
                        <div>
                          <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/city.webp'} className="img-fluid" alt="city" />
                          <h6>{val.name}</h6>
                        </div>
                      </Link>
                    );
                  })}
                </Dropdown.Menu>
              </Dropdown>
              <Dropdown>
                <Dropdown.Toggle variant="success" id="dropdown-basic" className='header-user-box'>
                  <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/user.webp'} className="img-fluid" alt="user" />
                </Dropdown.Toggle>
                <Dropdown.Menu className='header-drop'>
                  {!localStorage.getItem("token") ? (
                    <>
                      <Link to="/neighbour/login">
                        <div>
                          <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/loginnew.webp'} className="img-fluid" alt="profile" />
                          <h6>Sign In</h6>
                        </div>
                      </Link>

                      <Link to="/neighbour/register">
                        <div>
                          <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/signup.webp'} className="img-fluid" alt="profile" />
                          <h6>Sign Up</h6>
                        </div>
                      </Link>

                      <Link to="/business/login">
                        <div>
                          <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/userline.webp'} className="img-fluid" alt="ian" />
                          <h6>Business Sign In</h6>
                        </div>
                      </Link>

                      {/* <Link to="/contact-us">
                      <div>
                        <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/cnt.webp'} className="img-fluid" alt="cnt" />
                        <h6>Contact Us</h6>
                      </div>
                    </Link> */}
                    </>
                  ) : (
                    <>
                      <Link to={Number(localStorage.getItem("role")) === 1 ? "/neighbour/edit-profile" : "/business/edit-business"}>
                        <div>
                          <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/profile.webp'} className="img-fluid" alt="profile" />
                          <h6>Profile</h6>
                        </div>
                      </Link>
                      <Link to="#" onClick={logout}>
                        <div>
                          <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/logout.webp'} className="img-fluid" alt="profile" />
                          <h6>Logout</h6>
                        </div>
                      </Link>
                    </>
                  )}
                </Dropdown.Menu>
              </Dropdown>
            </div>
            <div class="d-block d-sm-none">
              <div className="header-loc-box">
                <Dropdown>
                  <Dropdown.Toggle variant="success" id="ciytdrop" className='header-loc-box'>
                    <h6 onClick={handleShow}> {cur_location.address ? cur_location.address : "Select Location"}</h6>
                    <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/location.webp'} className="img-fluid" alt="drop" onClick={getCurrentLocation} />
                  </Dropdown.Toggle>
                </Dropdown>
              </div>            
          </div>
            <div className=''>
              <Navbar expand="lg" expanded={expanded} onToggle={setExpanded} ref={navRef} className="bg-body-tertiary">
                <Container>
                  <Navbar.Toggle aria-controls="basic-navbar-nav" />
                  <Nav.Link href="/" className="hide-mob-logo">
                    {logo && (
                    <Image src={logo} className="img-fluid logo-bl" alt="logo-nei" />
                    )}
                  </Nav.Link>
                  <Navbar.Collapse id="basic-navbar-nav">
                    <Nav className="me-auto">
                      <Nav.Link href="/" className='lb-logo'>
                        {logo && (
                          <Image src={logo} className="img-fluid logo-nei" alt="logo-nei" />
                        )}
                      </Nav.Link>
                      <Nav.Link href="/">
                        <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/ldicn.webp'} className="img-fluid" alt="homeicn" />
                        <h6>Home</h6>
                      </Nav.Link>                      
                      {/*<Nav.Link href="/neighbour/local-dashboard">
                        <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/homeicn.webp'} className="img-fluid" alt="homeicn" />
                        <h6>Local Social</h6>
                      </Nav.Link>
                      <Nav.Link href="/neighbour/local-stories">
                        <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/lsicn.webp'} className="img-fluid" alt="lsicn" />
                        <h6>Local Stories</h6>
                      </Nav.Link>*/}
                      {/*<Nav.Link href="/neighbour/view-gallery">
                        <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/galicn.webp'} className="img-fluid" alt="galicn" />
                        <h6>Gallery</h6>
                      </Nav.Link>*/}
                    </Nav>
                  </Navbar.Collapse>
                </Container>
              </Navbar>
            </div>
          </div>
          {/*<div class="bt-location d-none">
              <div className="header-loc-box">
                <Dropdown>
                  <Dropdown.Toggle variant="success" id="ciytdrop" className='header-loc-box'>
                    <h5>Current Location : </h5>
                    <h6 onClick={handleShow}> {cur_location.address ? cur_location.address : "Select Location"}</h6>
                    <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/location.webp'} className="img-fluid" alt="drop" onClick={getCurrentLocation} />
                  </Dropdown.Toggle>
                </Dropdown>
              </div>            
          </div>*/}
        </Container>
      </section>
      <Modal
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
        centered
        className='add-city-modal'
      >
        <Modal.Header closeButton>
          <h3>Select Location</h3>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-3">
              <Form.Label className='d-none'>Pin code</Form.Label>
              <Form.Control type="text" placeholder="Pin code" name="pincode" onChange={handleInputChangeMo} onBlur={getpicode_town} value={inputsl.pincode} maxLength={6} />
              {errors.pincode && (<p className="text-danger">{errors.pincode}</p>)}
            </Form.Group>
            <div className='or-box'>
              <span>or</span>
            </div>
            <Form.Select aria-label="Default select example" name="state" onChange={getCity} value={inputsl.state}>
              <option value="">State</option>
              {state && state.map((val, index) => {
                  return (
                      <option value={val.id}>{val.name}</option>
                  )
              })}
            </Form.Select>
            {errors.state && (<p className="text-danger">{errors.state}</p>)}
            <Form.Select aria-label="Default select example" name="city" onChange={getTown} value={inputsl.city}>
              <option value="">City</option>
              {city && city.map((val, index) => {
                  return (
                      <option value={val.id}>{val.name}</option>
                  )
              })}
            </Form.Select>
            {errors.city && (<p className="text-danger">{errors.city}</p>)}
            <Form.Select aria-label="Default select example" name="town" onChange={getCat} value={inputsl.town}>
              <option value="">Locality</option>
              {town && town.map((val, index) => {
                  return (
                      <option value={val.id}>{val.name}</option>
                  )
              })}
            </Form.Select>
            {errors.town && (<p className="text-danger">{errors.town}</p>)}
            <Button type="button" className='blue-btn' onClick={submitdata}>Select</Button>
          </Form>
        </Modal.Body>
      </Modal>
    </>
  )
}

export default Topbar;                    